module.exports = __webpack_public_path__ + "static/media/numberline-owl.f17ac8b4.svg";